module.exports = __webpack_public_path__ + "img/5.b14b952a.jpg";